var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BnOffsetCard',{attrs:{"blockTitle":"Üzembentartó (szerződő) adatai","sectionFinished":false}},[(!_vm.$online && !_vm.isPapirmentes)?_c('BnUgyfelKivalaszt',{ref:"ugyfelkivalaszto",attrs:{"slot":"header","path":_vm.path},slot:"header"}):_vm._e(),_vm._v(" "),_c('div',{attrs:{"slot":"block-elements"},slot:"block-elements"},[_c('v-form',{ref:_vm.path + '_adatok'},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('BnFormField',{attrs:{"attributes":{
                            label: 'A biztosítás szerződője',
                            visible: true,
                            editable: _vm.editable && !_vm.isPapirmentes,
                            type: 'select',
                            mezo: this.path + '.sex',
                            path: this.path + '.sex',
                            options: [
                                   {key: 1, value: 'Férfi'},
                                   {key: 2, value: 'Nő'},
                                   {key: 3, value: 'Nem természetes személy'} ],
                            itemsText: 'value',
                            itemsValue: 'key',
                        }}}),_vm._v(" "),(_vm.isPerson)?_c('BnFormField',{key:"birthdate_input",attrs:{"attributes":{
                                label: 'Születési ideje',
                                visible: true,
                                editable: _vm.editable  && !_vm.isPapirmentes,
                                path: this.path + '.birthdate',
                                mezo: this.path + '.birthdate',
                                type: 'date',
                                blur: _vm.ugyfelKeresOpen,
                             }}}):_vm._e(),_vm._v(" "),(_vm.isPerson)?_c('BnFormField',{attrs:{"attributes":{
                                label: 'Titulus',
                                editable: _vm.editable && !_vm.isPapirmentes,
                                visible: true,
                                path: this.path + '.titulus',
                                mezo: this.path + '.titulus',
                                type: 'select',
                                resource: _vm.listTypes.titulus,
                                itemsText: 'value',
                                itemsValue: 'key',
                           }}}):_vm._e(),_vm._v(" "),(_vm.isPerson)?_c('BnFormField',{key:"name_input",attrs:{"attributes":{
                                label: 'Neve',
                                editable: _vm.editable && !_vm.isPapirmentes,
                                visible: true,
                                path: this.path + '.name',
                                mezo: this.path + '.name',
                                type: 'text',
                                textTransform: _vm.capitalize,
                                blur: _vm.ugyfelKeresOpen,
                           }}}):_vm._e(),_vm._v(" "),(_vm.isCompany)?_c('BnFormField',{attrs:{"attributes":{
                                label: 'Neve',
                                visible: true,
                                editable: _vm.editable,
                                path: this.path + '.cegnev',
                                mezo: this.path + '.cegnev',
                                type: 'text',
                          }}}):_vm._e(),_vm._v(" "),(_vm.isCompany)?_c('BnFormField',{key:"cegforma_input_field",attrs:{"attributes":{
                                label: 'Cégforma',
                                visible: true,
                                editable: _vm.editable,
                                path: this.path + '.cegforma',
                                mezo: this.path + '.cegforma',
                                type: 'select',
                                resource: _vm.listTypes.cegforma,
                                itemsText: 'value',
                                itemsValue: 'key',
                          }}}):_vm._e(),_vm._v(" "),(_vm.isCompany)?_c('BnFormField',{attrs:{"attributes":{
                                label: 'Adószáma',
                                visible: true,
                                editable: _vm.editable,
                                path: this.path + '.company_taxnumber',
                                mezo: this.path + '.company_taxnumber',
                                type: 'text',
                                mask: '###########',
                            }}}):_vm._e(),_vm._v(" "),(_vm.isCompany)?_c('BnTeaorInput',{key:"teaor_input_field",attrs:{"attributes":{
                                editable: _vm.editable,
                                path: this.path + '.teaor',
                                mezo: this.path + '.teaor',
                             }}}):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.isPerson || _vm.isCompany)?_c('BnIrszam',{attrs:{"attributes":{
                                    label: _vm.getValue(this.path+'.'+ 'sex') == 3
                                    ? 'Székhely irányítószáma'
                                    : 'Irányítószám',
                                    visible: true,
                                    editable: !_vm.isPapirmentes,
                                    path: this.path + '.' + 'address.zip',
                                    mezo: 'uzembentarto.cim.zip',
                                    width: 'xs12 md6'
                                }}}):_vm._e(),_vm._v(" "),(_vm.isPerson || _vm.isCompany)?_c('BnVaros',{attrs:{"zip":_vm.$store.getters.uzembentarto.address.zip,"attributes":{
                                    label: 'Település',
                                    visible: true,
                                    editable: !_vm.isPapirmentes,
                                    path: this.path + '.' + 'address.city_code',
                                    mezo: 'uzembentarto.cim.city_code',
                                    width: 'xs12 md6'
                                }}}):_vm._e(),_vm._v(" "),(_vm.isPerson || _vm.isCompany)?_c('BnFormField',{attrs:{"attributes":{
                                label: 'E-mail',
                                visible: true,
                                editable: _vm.editable,
                                path: this.path + '.email',
                                mezo: this.path + '.email',
                                type: 'email',
                          }}}):_vm._e(),_vm._v(" "),(_vm.isPerson || _vm.isCompany)?_c('BnFormField',{attrs:{"attributes":{
                                label: 'Telefonszám',
                                visible: true,
                                editable: _vm.editable,
                                path: this.path + '.mobil',
                                mezo: this.path + '.telefon',
                                type: 'text',
                          }}}):_vm._e()],1),_vm._v(" "),(_vm.isCompany)?_c('BnFormField',{attrs:{"attributes":{
                                label: 'A forgalmiban szereplő cím megegyezik a székhellyel.',
                                visible: true,
                                editable: _vm.editable,
                                path: 'tarifaData.forgcim_megegyezik',
                                mezo: 'forgcim_megegyezik',
                                type: 'checkbox',
                                width: 'md12 xs12'
                            }}}):_vm._e(),_vm._v(" "),(_vm.getValue('tarifaData.forgcim_megegyezik') !== true && _vm.isCompany)?_c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.isPerson || _vm.isCompany)?_c('BnIrszam',{attrs:{"attributes":{
                                    label: 'Forgalmiban szereplő irányítószám',
                                    visible: true,
                                    editable: true,
                                    path: 'tarifaData.forgalmi_cim.zip',
                                    mezo: 'uzembentarto.forgalmi_cim.zip',
                                    width: 'xs12 md6'
                                }}}):_vm._e(),_vm._v(" "),(_vm.isPerson || _vm.isCompany)?_c('BnVaros',{attrs:{"zip":_vm.$store.getters.tarifaData.forgalmi_cim.zip,"attributes":{
                                    label: 'Település',
                                    visible: true,
                                    editable: true,
                                    path: 'tarifaData.forgalmi_cim.city_code',
                                    mezo: 'uzembentarto.forgalmi_cim.city_code',
                                    width: 'xs12 md6'
                                }}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"ma-2"},[_c('v-divider')],1),_vm._v(" "),(_vm.isCompany)?_c('BnFormField',{attrs:{"attributes":{
                                label: 'Kér papíralapú számlát?',
                                visible: true,
                                editable: _vm.editable,
                                path: 'tarifaData.ker_szamla',
                                mezo: 'uzembentarto.ker_szamla',
                                type: 'select',
                                resource: _vm.listTypes.yesno,
                                itemsText: 'key',
                                itemsValue: 'value',
                      }}}):_vm._e(),_vm._v(" "),(_vm.isCompany)?_c('BnFormField',{attrs:{"attributes":{
                                label: 'Rendelkezik-e gépjármű kereskedelemi engedéllyel?',
                                visible: true,
                                editable: _vm.editable,
                                path: 'tarifaData.gepjker_eng',
                                mezo: 'uzembentarto.gepjker_eng',
                                type: 'select',
                                resource: _vm.listTypes.rendelkezem,
                                itemsText: 'key',
                                itemsValue: 'value',
                            }}}):_vm._e(),_vm._v(" "),(_vm.isCompany)?_c('BnFormField',{attrs:{"attributes":{
                                label: 'Rendelkezik-e gépjármű kölcsönzési engedéllyel?',
                                visible: true,
                                editable: _vm.editable,
                                path: 'tarifaData.gepjkolcs_eng',
                                mezo: 'uzembentarto.gepjkolcs_eng',
                                type: 'select',
                                resource: _vm.listTypes.rendelkezem,
                                itemsText: 'key',
                                itemsValue: 'value',
                            }}}):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.isPerson)?_c('BnFormField',{attrs:{"attributes":{
                        label: 'Rendelkezik jogosítvánnyal',
                        visible: true,
                        editable: _vm.editable && !_vm.isPapirmentes,
                        mezo: this.path + '.has_licence',
                        type: 'select',
                        path: this.path + '.has_licence',
                        resource: _vm.listTypes.yesno,
                        itemsText: 'key',
                        itemsValue: 'value',
                    }}}):_vm._e(),_vm._v(" "),(_vm.getValue(this.path + '.' + 'has_licence') && _vm.isPerson)?_c('BnFormField',{attrs:{"attributes":{
                        label: 'Jogosítvány megszerzésének a dátuma',
                        visible: true,
                        editable: _vm.editable && !_vm.isPapirmentes,
                        mezo: this.path + '.jogsi_datum',
                        type: 'date',
                        path: this.path + '.licence_date',
                    }}}):_vm._e(),_vm._v(" "),(_vm.isPerson)?_c('BnFormField',{attrs:{"attributes":{
                        label: 'A legfiatalabb gyermek születési éve',
                        visible: true,
                        editable: _vm.editable,
                        type: 'select',
                        path: 'tarifaData.ajanl_gyerek_szulev',
                        mezo: 'ajanl_gyerek_szulev',
                        resource: _vm.listTypes.gyerekEv,
                        itemsText: 'value',
                        itemsValue: 'key'
                    }}}):_vm._e(),_vm._v(" "),(_vm.isPerson && _vm.vanGfb)?_c('BnFormField',{attrs:{"attributes":{
                        label: 'Az Ön foglalkozása, tevékenysége',
                        visible: true,
                        editable: _vm.editable,
                        type: 'select',
                        path: 'tarifaData.mkb_munkahely',
                        mezo: 'mkb_munkahely',
                        resource: _vm.listTypes.mkb_munkahely,
                        itemsText: 'value',
                        itemsValue: 'key'
                    }}}):_vm._e(),_vm._v(" "),(_vm.isPerson && _vm.vanGfb)?_c('BnFormField',{attrs:{"attributes":{
                        label: 'Az Ön házastársa közszolgálati dolgozó?',
                        visible: true,
                        editable: _vm.editable,
                        type: 'select',
                        path: 'tarifaData.ajanl_kozszolga',
                        mezo: 'ajanl_kozszolga',
                        resource: _vm.listTypes.yesno,
                        itemsText: 'key',
                        itemsValue: 'value',
                    }}}):_vm._e(),_vm._v(" "),(_vm.isPerson && _vm.vanGfb)?_c('BnFormField',{attrs:{"attributes":{
                        label: 'Ön vagy közeli hozzátartozója polgárőr-e?',
                        visible: true,
                        editable: _vm.editable,
                        type: 'select',
                        path: 'tarifaData.polgaror',
                        mezo: 'polgaror',
                        options: [
                            {key: 'N', value: 'Nem'},
                            {key: 'Y', value: 'Igen a szerződő polgárőr'},
                            {key: 'K', value: 'Igen a szerződő közeli hozzátartozója polgárőr'} ],
                        itemsValue: 'key',
                        itemsText: 'value'
                    }}}):_vm._e(),_vm._v(" "),(_vm.isPerson && _vm.vanGfb)?_c('BnFormField',{attrs:{"attributes":{
                        label: 'Ön nyugdíjas?',
                        visible: true,
                        editable: _vm.editable,
                        type: 'select',
                        path: 'tarifaData.ajanl_nyugdijas',
                        mezo: 'ajanl_nyugdijas',
                        resource: _vm.listTypes.yesno,
                        itemsText: 'key',
                        itemsValue: 'value'
                    }}}):_vm._e(),_vm._v(" "),(_vm.isPerson && _vm.vanGfb)?_c('BnFormField',{attrs:{"attributes":{
                        label: 'Ön mozgáskorlátozott?',
                        visible: true,
                        editable: _vm.editable,
                        type: 'select',
                        path: 'tarifaData.ajanl_mozgaskorlatozott',
                        mezo: 'ajanl_mozgaskorlatozott',
                        resource: _vm.listTypes.mozgaskorlatozott,
                        itemsText: 'value',
                        itemsValue: 'key',
                    }}}):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }